import axios from "axios";
import { endpoints } from "config/api";
import { getAuthToken } from "utils/helper";

// ADD STAFF
export const addStaff = async (data) => {
  let request = await axios({
    method: "POST",
    url: endpoints.auth.ADD_STAFF,
    data: data,
    headers: {
      Authorization: getAuthToken(),
    },
  });
  return request;
};

// DELETE STAFF
export const deleteStaff = async (id) => {
  let request = await axios({
    method: "DELETE",
    url: `${endpoints.auth.DELETE_STAFF}/${id}`,
    headers: {
      Authorization: getAuthToken(),
    },
  });
  return request;
};

// EDIT STAFF
export const editStaff = async (body, id) => {
  let request = await axios({
    method: "PUT",
    url: `${endpoints.auth.EDIT_STAFF}/${id}`,
    data: body,
    headers: {
      Authorization: getAuthToken(),
    },
  });
  return request;
};

// GET STAFF BY ID
export const staffById = async (id) => {
  let request = await axios({
    method: "GET",
    url: `${endpoints.auth.GET_STAFF_BY_ID}/${id}`,
    headers: {
      Authorization: getAuthToken(),
    },
  });
  return request;
};

// GET STAFF
export const staffList = async (params) => {
  let request = await axios({
    method: "GET",
    url: endpoints.auth.GET_STAFF,
    headers: {
      Authorization: getAuthToken(),
    },
    params: params,
  });
  return request;
};

// ADD ROLE
export const addRole = async (data) => {
  let request = await axios({
    method: "POST",
    url: endpoints.auth.ADD_ROLE,
    data: data,
    headers: {
      Authorization: getAuthToken(),
    },
  });
  return request;
};

// EDIT ROLE
export const editRole = async (data, id) => {
  let request = await axios({
    method: "PUT",
    url: `${endpoints.auth.EDIT_ROLE}/${id}`,
    data: data,
    headers: {
      Authorization: getAuthToken(),
    },
  });
  return request;
};

// DELETE ROLE
export const deleteRole = async (id) => {
  let request = await axios({
    method: "DELETE",
    url: `${endpoints.auth.DELETE_ROLE}/${id}`,
    headers: {
      Authorization: getAuthToken(),
    },
  });
  return request;
};

// GET ROLE BY ID
export const roleById = (id) => {
  let request = axios({
    method: "GET",
    url: `${endpoints.auth.GET_ROLE_BY_ID}/${id}`,
    headers: {
      Authorization: getAuthToken(),
    },
  });
  return request;
};

// GET ROLE
export const roleList = async (params) => {
  let request = await axios({
    method: "GET",
    url: endpoints.auth.GET_ROLE,
    headers: {
      Authorization: getAuthToken(),
    },
    params: params,
  });
  return request;
};

export const getRoleDropDown = async () => {
  let request = await axios({
    method: "GET",
    url: endpoints.auth.GET_ROLE_DROPDOWN,
    headers: {
      Authorization: getAuthToken(),
    },
  });
  return request;
};
